import React from 'react';
import Box from '@mui/material/Box';
import { useTheme, alpha } from '@mui/material/styles';

// A read-only label shaped like a chip. MUI's Chip in this version calls its onClick even when none
// is given, so clicking a plain Chip crashes the page: review screens use this instead.
const Pill = ({ label, color = 'default', variant = 'filled', dashed = false, sx = {} }) => {
    const theme = useTheme();
    const main = color === 'default' ? theme.palette.text.secondary : theme.palette[color].main;
    const filled = variant === 'filled';

    let background = alpha(main, 0.12);
    let textColor = theme.palette.text.primary;
    if (filled && color !== 'default') {
        background = main;
        textColor = theme.palette[color].contrastText;
    } else if (!filled) {
        background = 'transparent';
        textColor = color === 'default' ? theme.palette.text.secondary : main;
    }

    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                height: 24,
                paddingX: 1.25,
                borderRadius: '12px',
                fontSize: 13,
                lineHeight: 1,
                whiteSpace: 'nowrap',
                backgroundColor: background,
                color: textColor,
                border: filled ? '1px solid transparent' : `1px ${dashed ? 'dashed' : 'solid'} ${alpha(main, color === 'default' ? 0.4 : 1)}`,
                borderWidth: dashed ? 2 : 1,
                ...sx,
            }}
        >
            {label}
        </Box>
    );
};

export default Pill;
